import React, { useCallback, useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Radio, Tooltip } from "src/assets/imports/antdComponents";
import { setDateRangeSlicer, toggleNotesFilterDrawer as toggleNotesFilterDrawer } from "../../states/notesInsightsSlice";
import { RootState } from "src/store";
import { DateRangeSlicerType, IDateRange } from "../../models/interfaces";
import SplitByDropdown from "./SplitByDropdown";
import "./style.css";

const NotesFilterPane = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const { dateRangeSlicer, allDateRanges, notesError, dateRangeDisabled, selectedFilters } = useSelector((state: RootState) => state.notesInsightsSlice);
	const { selectedStudy } = useSelector((state: RootState) => state.studiesSlice);
	const [selectedDateRange, setSelectedDateRange] = useState<string>(dateRangeSlicer);

	useEffect(() => {
		setSelectedDateRange(dateRangeSlicer);
	}, [dateRangeSlicer]);

	const handleDateRangeChange = useCallback(
		(e) => {
			const value = e.target.value;
			setSelectedDateRange(value);
			dispatch(setDateRangeSlicer(value));
		},
		[dispatch, allDateRanges]
	);

	const radioOptions = useMemo(
		() =>
			Object.entries(allDateRanges)?.map(([key, range]: [string, IDateRange]) => {
				return (
					<Tooltip
						key={key}
						overlayClassName="notes-tooltip-reduced-padding"
						placement={key.toLowerCase() === DateRangeSlicerType.Max ? "bottomRight" : "bottom"}
						title={
							selectedStudy?.is_date_mapped ? (
								dateRangeDisabled?.[key] ? (
									<div className="text-[x-small] flex flex-col">
										<span>{t("No data available")}</span>
									</div>
								) : (
									<div className="text-[x-small] flex flex-col">
										<span>
											{dayjs(range?.start).format("MMM'YY")} - {dayjs(range?.end).format("MMM'YY")}
										</span>
									</div>
								)
							) : key === "Max" ? (
								<div className="text-[x-small] flex flex-col">
									<span>{t("Date not available")}</span>
								</div>
							) : (
								<div className="text-[x-small] flex flex-col">
									<span>{t("No data available")}</span>
								</div>
							)
						}>
						<Radio.Button value={key} disabled={dateRangeDisabled?.[key]}>
							{key.charAt(0).toUpperCase() + key.slice(1)}
						</Radio.Button>
					</Tooltip>
				);
			}),
		[allDateRanges]
	);

	if (notesError) {
		return null;
	}

	return (
		<div className="z-10 w-full">
			<div className="flex justify-between gap-8">
				<div className="flex items-center w-2/4">
					{/* <SplitByDropdown /> */}
					{/* <Button type="primary" className="notes-filter-pane-split-by-btn" onClick={openSplitByDrawer}>
							<Document_Filter_Icon />
							{t("Split By")}
							<i className="material-symbols-outlined -mx-2">keyboard_arrow_right</i>
						</Button> */}
				</div>
				<div className="flex items-center justify-end gap-3 w-2/4">
					{allDateRanges["Max"]?.start && allDateRanges["Max"]?.end ? (
						<div className="text-[x-small] flex gap-2">
							<span>{t("Range")}:</span>
							{selectedStudy?.is_date_mapped ? (
								<div>
									{dayjs(allDateRanges["Max"]?.start).format("MMM'YY")} - {dayjs(allDateRanges["Max"]?.end).format("MMM'YY")}
								</div>
							) : (
								<div>{t("Not available")}</div>
							)}
						</div>
					) : null}
					<div className="flex">
						<Radio.Group
							className="notes-insights-radio-btn-grp"
							onChange={handleDateRangeChange}
							value={selectedDateRange}
							defaultValue={selectedDateRange}
							size="small">
							{radioOptions}
						</Radio.Group>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(NotesFilterPane);
